<app-admin></app-admin>
 
<div class="tabs" (click)="tabChanged(1)" style="float: left;margin-left: 84px;">
        <div class="image">
            <img src="../../assets/images/uib-grid-tile-logo.png">
        </div>
        <div class="tabName">
            Application message count
        </div>
</div>
<div class="tabs" (click)="tabChanged(2)" style="margin-left: 491px;">
    <div class="image">
        <img src="../../assets/images/uib-grid-tile-logo.png">
    </div>
    <div class="tabName">
        Reseller view
    </div>
</div>

<div class="tabs s1" (click)="tabChanged(3)" style="margin-top: -300px;margin-left: 908px;">
    <div class="image" style="height: 201px">
        <img src="../../assets/images/uib-grid-tile-logo.png">
    </div>
    <div class="tabName" style="margin-top: -11px;"> 
        Reseller total message count
    </div>
</div>

<div class="tabs" (click)="tabChanged(4)" style="float: left;margin-top: 80px;margin-bottom: 100px;margin-left: 85px;">
    <div class="image" style="height: 201px">
        <img src="../../assets/images/uib-grid-tile-logo.png">
    </div>
    <div class="tabName">
        Monthly Active User
    </div>
</div>
<!-- <div class="tabs" (click)="tabChanged(5)" style="float: left;margin-top: 80px;margin-bottom: 100px;margin-left: 85px;">
    <div class="image" style="height: 201px">
        <img src="../../assets/images/uib-grid-tile-logo.png">
    </div>
    <div class="tabName">
        WhatsApp Pricing
    </div>
</div> -->